<template>
  <div class="container" @dragover.prevent="activeDragLayer" @drop.prevent="hideDragLayer">
    <div class="d-flex flex-column">
      <el-breadcrumb >
        <el-breadcrumb-item :to="Paths.HOMEPAGE">Trang chủ</el-breadcrumb-item>
        <el-breadcrumb-item :to="Paths.GROUP_MANAGEMENT">Nhóm</el-breadcrumb-item>
        <el-breadcrumb-item>{{ groupInfo.name }}</el-breadcrumb-item>
      </el-breadcrumb>

      <div class="d-flex flex-column">
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="6">
            <h1 class="heading_one">{{ groupInfo.name }}</h1>
          </el-col>
        </el-row>
      </div>

<!--      <div class="d-flex flex-column align-items-end">-->
<!--        <div style="margin: 5px 0px 5px 0px">-->
<!--          <el-dropdown @command="downloadAll">-->
<!--            <el-button type="primary" size="small">Tải tất cả </el-button>-->
<!--            <el-dropdown-menu slot="dropdown">-->
<!--              <el-dropdown-item command="raw">-->
<!--                <FAIcon icon="fas fa-file-download" :color="Colors.RAW" />Tải file gốc-->
<!--              </el-dropdown-item>-->
<!--              <el-dropdown-item command="general_report" v-if="hasPermission('VIEW')">-->
<!--                <FAIcon icon="fas fa-chart-pie dodgerblue" />&nbsp; Báo cáo chi tiết-->
<!--              </el-dropdown-item>-->
<!--              <el-dropdown-item command="highlight_report" v-if="hasPermission('VIEW')">-->
<!--                <FAIcon icon="fas fa-list-alt orangered" />&nbsp; Báo cáo tóm tắt-->
<!--              </el-dropdown-item>-->
<!--            </el-dropdown-menu>-->
<!--          </el-dropdown>-->
<!--        </div>-->
<!--      </div>-->
      <div class="drop-layer" :class="dropLayerState" @dragleave.prevent="hideDragLayer" @drop.prevent="dropHandler">
        <div style="text-align: center">
          <svg
            width="12rem"
            height="12rem"
            viewBox="0 0 16 16"
            class="bi bi-file-earmark-arrow-up"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 0h5.5v1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h1V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z"
            />
            <path d="M9.5 3V0L14 4.5h-3A1.5 1.5 0 0 1 9.5 3z" />
            <path
              fill-rule="evenodd"
              d="M8 12a.5.5 0 0 0 .5-.5V7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-2-2a.5.5 0 0 0-.708 0l-2 2a.5.5 0 1 0 .708.708L7.5 7.707V11.5a.5.5 0 0 0 .5.5z"
            />
          </svg>
          <h2 style="margin-top: 10px">Kéo thả tài liệu vào đây !</h2>
        </div>
      </div>
      <VueGoodTable
        mode="remote"
        @on-cell-click="viewDetail"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-per-page-change="onPerPageChange"
        @on-selected-rows-change="onSelect"
        @on-search="onSearch"
        :isLoading.sync="isLoading"
        :columns="columns"
        :rows="documentsRender"
        :totalRows="totalRecords"
        :search-options="{
          enabled: true,
          placeholder: 'Tìm kiếm',
        }"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          rowsPerPageLabel: 'Số hàng mỗi trang',
          nextLabel: 'Trang trước',
          prevLabel: 'Trang sau',
          ofLabel: 'trong',
        }"
        styleClass="vgt-table striped bordered"
      >
        >

        <div slot="emptystate">Danh sách tài liệu của bạn đang trống</div>

        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field === 'action'" class="d-flex flex-row justify-content-around">
            <FAIcon icon="fas fa-file-download"
                    :color="Colors.RAW"
                    title="Tải tài liệu gốc"
                    :disabled="props.row.status === DocumentState.DELETED"
                    @click="handleDownloadDocument(props.row.slug, props.row.name, DownloadType.RAW)"/>
            <FAIcon icon="fas fa-chart-pie"
                    :color="Colors.REPORT"
                    title="Tải báo cáo"
                    :disabled="props.row.status !== DocumentState.COMPLETE_PROCESS"
                    @click="$refs[refs.DOCUMENT_REPORT_MODAL].openModal(props.row)"/>
          </div>
          <span v-else-if="props.column.field === 'status'">
            <DocumentStatus :status="props.row.status" />
          </span>
          <span v-else-if="props.column.field === 'title'">
            <CommonLink
              :to="Paths.DOCUMENT_RESULT_VIEW(DocumentTypes.GROUP_DOCUMENT, props.row.slug)"
              :disable="props.row.status !== DocumentState.COMPLETE_PROCESS"
            >
              {{ props.row.title }}
            </CommonLink>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <template slot="loadingContent">
          <span class="vgt-loading__content"> Đang tải... </span>
        </template>
      </VueGoodTable>
      <GroupDocumentReportModal :ref="refs.DOCUMENT_REPORT_MODAL" @success="loadItems" />
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import '@/assets/css/vue-good-table.css'
import 'moment/locale/vi'
import {
  apiDownloadALlDocumentInGroup,
  apiDownloadBatchGroupDocument,
  apiDownloadGroupDocumentAsArrayBuffer,
  apiGetAllDocumentByGroup,
} from '@/services/document_management_service'
import { ComponentType, DocumentState, DownloadType, RouteNames, Table } from '@/constants/DoITConstant'

import { pushArraybuffer2Client } from '@/helpers/DownloadHelper'
import { getGroupInfo } from '@/services/group_management_service'
import { hasRoleAdmin } from '@/services/user_service'
import GroupDownloadReport from '@/components/GroupsManagement/GroupDownloadReport'
import DocumentEdit from '@/components/GroupDocumentManagement/DocumentEdit.vue'
import DocumentDelete from '@/components/GroupDocumentManagement/DocumentDelete.vue'
import AppendForm from '@/components/GroupDocumentManagement/AppendForm.vue'
import { Paths } from '@/routes/paths.js'
import { formatDateTime } from '@/helpers/timeHelper.js'
import {Colors, DocumentTypes} from '@/constants/DoITConstant.js'
import DocumentStatus from '@/components/common/document/DocumentStatus.vue'
import GroupDocumentEditModal from '@/components/GroupDocumentManagement/action-modals/GroupDocumentEditModal.vue'
import GroupDocumentDeleteModal from '@/components/GroupDocumentManagement/action-modals/GroupDocumentDeleteModal.vue'
import FAIcon from '@/components/common/FAIcon.vue'
import GroupDocumentReportModal from '@/components/GroupsManagement/action-modals/GroupDocumentReportModal.vue'
import CommonLink from '@/components/common/CommonLink.vue'

export default {
  name: 'UserGroupDocumentView',
  components: {
    GroupDocumentReportModal,
    GroupDocumentDeleteModal,
    GroupDocumentEditModal,
    DocumentStatus,
    GroupDownloadReport,
    VueGoodTable,
    DocumentEdit,
    DocumentDelete,
    AppendForm,
    FAIcon,
    CommonLink
  },
  props: {},
  data: function () {
    return {
      columns: [],
      componentType: ComponentType.GROUPDOCUMENT,
      groupInfo: {},
      DownloadType: DownloadType,
      totalRecords: 0,
      DocumentState,
      serverParams: {
        sortAscending: false,
        sortField: 'uploadTime',
        page: 0,
        size: 10,
      },
      Paths,
      Colors,
      DocumentTypes,
      selectedRowSlugs: [],
      documents: [],
      interval: null,
      droppedFiles: [],
      dropLayerState: 'hidden',
      isLoading: true,
      refs: {
        DOCUMENT_REPORT_MODAL: 'DOCUMENT_REPORT_MODAL',
      },
    }
  },
  async mounted() {
    let resInfo = await getGroupInfo(this.$route.params.id)
    if (resInfo == null) {
      this.$message.error('Có lỗi xảy ra')
      setTimeout(() => this.$router.go(-1), 2000)
    } else {
      this.groupInfo = resInfo
    }

    this.columns = [
      {
        label: 'Tiêu đề',
        field: 'title',
      },
      {
        label: 'Độ trùng lặp',
        field: 'score',
        formatFn: (score) => (score !== null ? `${score} %` : ''),
      },
      {
        label: 'Ngày tải lên',
        field: 'uploadTime',
        formatFn: formatDateTime,
      },
      {
        label: 'Trạng thái',
        field: 'status',
      },
      {
        label: 'Hành động',
        field: 'action',
        sortable: false,
        width: '120px'
      },
    ]
    this.loadItems().then()
    this.interval = setInterval(() => {
      if (this.selectedRowSlugs.length === 0) {
        this.loadItems()
      }
    }, Table.RELOAD_INTERVAL)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    hasPermission(permission) {
      return this.groupInfo.permissions && this.groupInfo.permissions.includes(permission)
    },
    async handleDownloadDocument(slug, name, type) {
      let res = await apiDownloadGroupDocumentAsArrayBuffer(slug, type)
      pushArraybuffer2Client(res, name)
    },
    viewDetail(slug, status) {
      if (status) {
        if (status === DocumentState.DELETED) {
          this.$message({
            message: 'Tài liệu đã bị xóa',
            type: 'error',
          })
        } else if (status === DocumentState.ERROR) {
          this.$message({
            message: 'Quá trình kiểm tra tài liệu xảy ra lỗi',
            type: 'error',
          })
        } else if (status === DocumentState.COMPLETE_PROCESS) {
          let routeData = this.$router.resolve({
            name: 'document_result',
            params: { slug: slug, documentType: 'group' },
          })
          window.open(routeData.href, '_blank')
        } else {
          this.$message({
            message: 'Tài liệu chưa xử lý xong',
            type: 'warning',
          })
        }
      }
    },

    onSearch(params) {
      this.serverParams.searchKey = params.searchTerm
      this.loadItems()
    },

    onPageChange(params) {
      this.serverParams.page = params.currentPage - 1
      this.loadItems()
    },

    onPerPageChange(params) {
      this.serverParams.size = params.currentPerPage
      this.loadItems()
    },

    onSortChange(params) {
      this.serverParams.sortAscending = params[0].type === 'asc'
      this.serverParams.sortField = params[0].field
      this.serverParams.page = 0
      this.loadItems()
    },
    async loadItems() {
      this.isLoading = true
      let responseAllDocument = await apiGetAllDocumentByGroup(this.$route.params.id, this.serverParams)
      this.documents = responseAllDocument.data
      this.totalRecords = responseAllDocument.meta.total
      this.isLoading = false
    },
    onSelect(params) {
      this.selectedRowSlugs = new Set()
      params.selectedRows.forEach((row) => this.selectedRowSlugs.add(row.slug))
    },
    async downloadBatch(type) {
      if (this.selectedRowSlugs.size === 0) return
      let res = await apiDownloadBatchGroupDocument(this.selectedRowSlugs, type)
      pushArraybuffer2Client(res, 'selected_' + new Date().getTime() + type + '.zip')
    },

    async downloadAll(type) {
      let res = await apiDownloadALlDocumentInGroup(this.groupInfo.id, type)
      pushArraybuffer2Client(res, 'all_' + this.groupInfo.id + new Date().getTime() + type + '.zip')
    },
    dropHandler(e) {
      e.preventDefault()
      e.stopPropagation()
      let files = Array.from(e.dataTransfer.files)
      let acceptedFiles = []
      files.forEach((file) => {
        let fileType = file.name.split('.').slice(-1)[0]
        let isAccepted = fileType === 'doc' || fileType === 'docx' || fileType === 'pdf' || fileType === 'zip'
        if (isAccepted) {
          acceptedFiles.push(file)
        } else {
          this.$message({
            message: 'Tài liệu tải lên không đúng định dạng',
            type: 'error',
          })
        }
      })
      this.droppedFiles = [...this.droppedFiles, ...acceptedFiles]
      this.dropLayerState = 'hidden'
    },
    activeDragLayer(e) {
      this.dropLayerState = ' active'
    },
    hideDragLayer(e) {
      this.dropLayerState = 'hidden'
    },
    removeAllFileInDroppedList() {
      this.droppedFiles = []
    },
  },
  computed: {
    documentsRender() {
      if (hasRoleAdmin()) {
        return this.documents
      } else {
        return this.documents.filter((value) => !(value.status === -1))
      }
    },
  },
}
</script>

<style scoped>
.icn {
  color: #0063fa;
  cursor: pointer;
}
.dodgerblue {
  color: dodgerblue;
}
.mediumseagreen {
  color: mediumseagreen;
}
.orangered {
  color: orangered;
}
.drop-layer {
  display: flex;
  flex-direction: row;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  height: 70%;
  background: rgba(52, 73, 94, 0.3);
  z-index: 88888;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 10px rgb(0, 0, 0);
  border: 5px dashed rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}
.hidden {
  display: none;
}
.active {
  display: flex;
}
</style>
